<template>
  <div>
    <div class="huxing">
      <van-row :gutter="10">
        <van-col :span="12" class="border">
          <div :class="{'form-box-tag':true}" @click="swap()">
            {{loucheng1}}
            <small>/所在楼层</small>
          </div>
        </van-col>
        <van-col :span="12" class="border">
          <div :class="{'form-box-tag':true}" @click="swap()">
            {{loucheng2}}
            <small>/总楼层</small>
          </div>
        </van-col>
      </van-row>
      <van-popup v-model="showPicker" position="bottom">
        <van-nav-bar
          title
          left-text="取消"
          right-text="确认"
          @click-left="showPicker=false"
          @click-right="onEnter"
        />
        <van-row>
          <van-col span="12">
            <van-picker :columns="lists[0]" ref="onStart" />
          </van-col>
          <van-col span="12">
            <van-picker :columns="lists[1]" ref="onEnd" />
          </van-col>
        </van-row>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Picker, Row, Col, Tag, Popup, NavBar } from "vant";

export default {
  components: {
    [Picker.name]: Picker,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar
  },

  data() {
    return {
      showPicker: false,
      loucheng1: this.select1,
      loucheng2: this.select2
    };
  },
  props: {
    lists: Array,
    select1: {
      type: String,
      default: "选择"
    },
    select2: {
      type: String,
      default: "选择"
    }
  },
  watch: {
    select1: function() {
      if (this.select1 != "") {
        this.loucheng1 = this.select1;
      }
    },
    select2: function() {
      if (this.select2 != "") {
        this.loucheng2 = this.select2;
      }
    }
  },
  mounted() {},

  methods: {
    swap(index, value) {
      this.showPicker = true;

      // this.$emit("selectFunc", value);
    },
    onEnter() {
      this.showPicker = false;
      var arr = this.$refs.onStart
        .getValues()
        .concat(this.$refs.onEnd.getValues());
      this.loucheng1 = this.$refs.onStart.getValues()[0];
      this.loucheng2 = this.$refs.onEnd.getValues()[0];
      this.$emit("change", arr);
    }
  }
};
</script>

<style scoped>
.huxing {
  background: #f8f8f8;
  padding: 10px;
}
.huxing .border {
  border-right: #f0f0f0 1px solid;
}
.huxing .border:last-child {
  border-right: none;
}
.form-box-tag {
  background-color: #f8f8f8;
  line-height: 32px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
}
.form-box-tag.active {
  background-color: #feefe9;
  color: #f56229;
}
.form-box-tag small {
  font-size: 12px;
  color: #aaa;
}
</style>>



